import {
    CHANGE_DATE_START,
    CHANGE_DATE_END,
    SESSION_ACCESS_DENIED
} from '../actions';

export const changeDateStart = (dateStart) => {
    return (
        {
            type: CHANGE_DATE_START,
            payload: dateStart
        }
    )
}

export const changeDateEnd = (dateEnd) => {
    return (
        {
            type: CHANGE_DATE_END,
            payload: dateEnd
        }
    )
}

export const sessionDenied = (sessionDenied) => {
    return (
        {
            type: SESSION_ACCESS_DENIED,
            payload: sessionDenied
        }
    )
}
